import { useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export function MaintenanceCard() {
  const [m, setM] = useState(null);
  const [minutes, setMinutes] = useState("20");
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/maintenance").then((r) => setM(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (enabled) => {
    if (!pin) { toast.error("Masukkan PIN Super Admin"); return; }
    setBusy(true);
    try {
      await api.post("/maintenance", { enabled, minutes: Number(minutes) || 20, pin });
      toast.success(enabled ? `Mode update AKTIF — agen diblokir ${minutes} menit` : "Mode update dimatikan — sistem kembali normal");
      setPin("");
      load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Card className={`bg-card border-border shadow-sm ${m?.enabled ? "border-amber-500/60" : ""}`} data-testid="maintenance-card">
      <CardHeader>
        <CardTitle className="text-base font-heading flex items-center gap-2"><Wrench className="w-4 h-4 text-amber-500" /> Mode Update / Pemeliharaan
          {m?.enabled && <span className="ml-auto text-[10px] font-mono px-2 py-0.5 rounded bg-amber-500/20 text-amber-500" data-testid="maintenance-status">AKTIF s/d {m.until ? new Date(m.until).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" }) : "-"}</span>}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-xs text-muted-foreground">Aktifkan sebelum deploy. Semua agen melihat layar "Sistem sedang di-update" dan transaksi (cetak voucher, deposit, transfer) ditolak sementara. Super Admin tetap bisa bekerja. Otomatis mati setelah waktu habis.</p>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5"><Label>Durasi (menit)</Label><Input type="number" min="1" max="240" value={minutes} onChange={(e) => setMinutes(e.target.value)} data-testid="maintenance-minutes" /></div>
          <div className="space-y-1.5"><Label>PIN Super Admin</Label><Input type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="PIN" data-testid="maintenance-pin" /></div>
        </div>
        <div className="flex gap-2">
          <Button className="bg-amber-600 hover:bg-amber-500 text-white" disabled={busy || m?.enabled} onClick={() => toggle(true)} data-testid="maintenance-on">Aktifkan Mode Update</Button>
          <Button variant="outline" disabled={busy || !m?.enabled} onClick={() => toggle(false)} data-testid="maintenance-off">Matikan (Sistem Normal)</Button>
        </div>
      </CardContent>
    </Card>
  );
}
